// @ts-nocheck
import React from 'react';
import { Route, Routes } from 'react-router';

import Home from './leftmenus/Home';
import Game from './leftmenus/Game';
import Company from './leftmenus/Company';
import User from './leftmenus/User';
import Keys from './leftmenus/Keys';
import Promotion from './leftmenus/Promotion';
import Pricing from './leftmenus/Pricing';
import Reports from './leftmenus/Reports';
import Requests from './leftmenus/Requests';
import Settings from './leftmenus/Settings';
import LeftNavWrapper from './menu-components/LeftNavWrapper';
import LeftMenuItem from './menu-components/LeftMenuItem';
import userTypes from '../../constants/userTypes';
import icons from '../../constants/icons';
import { CurrentDateAsString } from '../../util/formatter';
import { useTranslation } from 'react-i18next';

function LeftMenu({ currentUser, companyTypes }) {
  const { t } = useTranslation();
  const version = `v${window.globalConfig?.version || CurrentDateAsString()}`;
  return (
    <div id="panelFlyout" className="panel-flyout">
      <div className="panel-flyout__inner">
        <div id="scroll">
          <nav className="hide-phablet" role="navigation">
            <Routes>
              <Route
                path="/"
                element={
                  <Home currentUser={currentUser} companyTypes={companyTypes} />
                }
              />
              <Route
                path="/settings/*"
                element={<Settings currentUser={currentUser} />}
              />
              <Route
                path="/games/*"
                element={<Game currentUser={currentUser} />}
              />
              <Route
                path="/game/*"
                element={<Game currentUser={currentUser} />}
              />
              <Route
                path="/franchises/*"
                element={<Game currentUser={currentUser} />}
              />
              <Route
                path="/sku/*"
                element={<Game currentUser={currentUser} />}
              />
              <Route
                path="/companies/*"
                element={
                  <Company
                    currentUser={currentUser}
                    companyTypes={companyTypes}
                  />
                }
              />
              <Route
                path="/company/*"
                element={
                  <Company
                    currentUser={currentUser}
                    companyTypes={companyTypes}
                  />
                }
              />
              <Route
                path="/users/*"
                element={
                  <User currentUser={currentUser} companyTypes={companyTypes} />
                }
              />
              <Route
                path="/user/*"
                element={
                  <User currentUser={currentUser} companyTypes={companyTypes} />
                }
              />
              <Route
                path="/keys/*"
                element={<Keys currentUser={currentUser} />}
              />
              <Route
                path="/requests/*"
                element={<Requests currentUser={currentUser} />}
              />
              <Route
                path="/reports/*"
                element={<Reports currentUser={currentUser} />}
              />
              <Route
                path="/request/*"
                element={<Requests currentUser={currentUser} />}
              />
              <Route
                path="/promotions/*"
                element={<Promotion currentUser={currentUser} />}
              />
              <Route
                path="/promotion/*"
                element={<Promotion currentUser={currentUser} />}
              />
              <Route
                path="/pricing/*"
                element={<Pricing currentUser={currentUser} />}
              />
            </Routes>
            <LeftNavWrapper>
              <LeftMenuItem
                url="/settings"
                activeRegex="^\/settings\/?(\?.*)?$"
                end={true}
                icon={icons.SETTINGS}
                title={t('Settings')}
                allowedUserTypes={[userTypes.ADMIN]}
                currentUser={currentUser}
                spinOnOver={true}
              />
            </LeftNavWrapper>
          </nav>
          <div className="brandInfo">
            <span>&copy; 2017-{new Date().getFullYear()}</span>
            <a
              href="https://K3YS.co/"
              target="_blank"
              rel="noopener noreferrer"
              className="ms-2"
            >
              K3YS.co
            </a>
            <span>{version}</span>
          </div>
        </div>
      </div>
    </div>
  );
}



export default LeftMenu;
